<template>
  <div class="introduce-text">
        <p>gjTool.js是一个轻量级javascript类库，快捷实现各类DOM操作与CSS效果。PC端和移动端均适用。gjTool使用方法和API与jQuery类似，相比更轻量。相当于简版jq。目前版本兼容至IE6。</p>
        <p>使用方式：</p><br />
        <pre>
// CommonJS 或者 AMD
//首先安装gjtool
npm install gjtool

//然后引用
import gjTool from "gjtool";  
//var gjTool = require("gjtool");

//html页面引入
&lt;script  src="gjtool.js">&lt;/script> 

//使用方式，例如：
gjTool('#test').show(); 
//$('#test').hide();
        </pre>
        
    </div>
</template>
<script>
export default {
  
}
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/component/introduce.vue